import type { CdkDrag } from '@angular/cdk/drag-drop';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

type Boundary = InstanceType<typeof CdkDrag>['boundaryElement'];

@UntilDestroy()
@Component({
  selector: 'y42-canvas-main-toolbar',
  templateUrl: './canvas-main-toolbar.component.html',
  styleUrls: ['./canvas-main-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CanvasMainToolbarComponent {
  @Input() position = {
    left: 'auto',
    top: '10px',
    right: '10px',
  };

  @Input() dragBoundary: Boundary = '';
}
